export default {
  NAME: 'Inter',
  SIZE_BASE: 16,
  WEIGHT: {
    REGULAR: 400,
    MEDIUM: 500,
    BOLD: 700,
  },
};
